import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { useFilterContext } from '../../FilterProvider';
import { useTranslation } from 'react-i18next';

const PromotionCode = () => {
  const { t } = useTranslation();
  const { filters, updateFilters } = useFilterContext();
  const [promotionCode, setPromotionCode] = useState(filters.promotionCode);

  const handleClick = () => {
    updateFilters({ promotionCode });
  };

  return (
    <div>
      <div className="py-1">
        <span className="me-2 pe-1 fw-bold">{t('common:promotionCode')}</span>
      </div>
      <InputGroup size="sm">
        <Form.Control name="promotionCode" value={promotionCode} onChange={(e) => setPromotionCode(e.target.value)} />
        <Button onClick={handleClick}>{t('common:apply')}</Button>
      </InputGroup>
    </div>
  );
};
export { PromotionCode };
